import React from "react";
import { pallette } from "../../config/pallette";

import Layout from "../../components/Layout";
import ArrowRight from "../../components/Icons/ArrowRightIcon";
import backgroundImage from "../../assets/background-landing.png";
import backgroundImageMobile from "../../assets/background-landing-mobile.png";

import {
  Container,
  SectionTop,
  TopSubtitle,
  Underline,
  TopTitle,
  TopBody,
  TopWrapper,
  SectionBody,
  SectionBottom,
  SectionTitle,
  LaunchButton,
  LaunchButtonText,
  LearnSection,
  LearnCard,
  LearnCardTitle,
  LearnCardTitleMobile,
  LearnCardBody,
} from "./styles";

const LEARN_CARDS = [
  {
    title: "Be clear, specific and concise",
    body: "Be <b>clear</b> and <b>specific</b> in your question. The more context you can provide the more likely you are to get a tailored response.",
  },
  {
    title: "Ask follow-ups",
    body: "Use follow-up questions to probe and get a better understanding of the replies provided.",
  },
  {
    title: "Rate responses",
    body: "Rate responses using the thumbs up or thumbs down. If the answer hasn’t been helpful, you can provide additional feedback which will help us improve the responses and experience for next time.",
  },
  {
    title: "Avoid vague statements",
    body: "Asking open ended questions or providing vague statements will result in an unhelpful response.",
  },
  {
    title: "Stay on topic",
    body: "SH+ Assistant is currently only trained on data specific to the course you are enrolled on, therefore it will be unable to provide any answers to questions outside this remit.",
  },
  {
    title: "Stick to English",
    body: "SH+ Assistant can only respond to questions in English. All questions should also be asked in English.",
  },
];

function formatItemTitleMobile(title) {
  switch (title) {
    case "Be clear, specific and concise":
      return (
        <p style={{ margin: 0, padding: 0 }}>
          Be clear, specific <br />
          and concise
        </p>
      );
    case "Ask follow-ups":
      return (
        <p style={{ margin: 0, padding: 0 }}>
          Ask <br />
          follow-ups
        </p>
      );
    case "Rate responses":
      return (
        <p style={{ margin: 0, padding: 0 }}>
          Rate <br />
          responses
        </p>
      );
    case "Avoid vague statements":
      return (
        <p style={{ margin: 0, padding: 0 }}>
          Avoid <br />
          vague statements
        </p>
      );
    case "Stay on topic":
      return (
        <p style={{ margin: 0, padding: 0 }}>
          Stay
          <br />
          on topic
        </p>
      );
    case "Stick to English":
      return (
        <p style={{ margin: 0, padding: 0 }}>
          Stick
          <br />
          to English
        </p>
      );
    default:
      return title;
  }
}

const Landing = () => {
  return (
    <Layout>
      <Container>
        <SectionTop
          bgimage={backgroundImage}
          bgimagemobile={backgroundImageMobile}
        >
          <TopWrapper>
            <TopSubtitle>Why SH+ Assistant</TopSubtitle>
            <Underline />
            <TopTitle>Enhance your learning journey</TopTitle>
            <TopBody>
              Use the SH+ Assistant and get instant answers to your technical
              questions. Your digital tutor at your fingertips.
            </TopBody>
            <LaunchButton topbutton="true" to="/chatbot">
              <LaunchButtonText topbutton="true">
                Launch SH+ Assistant
              </LaunchButtonText>
              <ArrowRight color={pallette.white} />
            </LaunchButton>
          </TopWrapper>
        </SectionTop>
        <SectionBottom>
          <SectionTitle>Meet your SH+ Assistant</SectionTitle>
          <SectionBody>
            Preparing for the ACCA exams can be challenging, but you don’t have
            to do it alone. Meet SH+ Assistant, your smart study sidekick. Powered by AI, 
            it’s an additional resource available via your Study Hub+ course. SH+
            Assistant is accessible 24/7 offering instant replies to make your
            exam prep easier, smarter and less stressful.
          </SectionBody>
          <SectionBody>
            Whether you’re grappling with a technical concept, or seeking a
            clear explanation, SH+ Assistant has your back. Ask questions, get
            clarifications and unlock the confidence to understand technical
            topics better.
          </SectionBody>
          <SectionBody>
            You can make the most out of this resource by following the
            guidelines below:
          </SectionBody>
          <LearnSection>
            {LEARN_CARDS.map((item, index) => (
              <div key={index}>
                <LearnCard>
                  {window.innerWidth > 430 ? (
                    <LearnCardTitle>{item.title}</LearnCardTitle>
                  ) : (
                    <LearnCardTitleMobile>
                      {formatItemTitleMobile(item.title)}
                    </LearnCardTitleMobile>
                  )}
                  <LearnCardBody
                    dangerouslySetInnerHTML={{ __html: item.body }}
                  />
                </LearnCard>
              </div>
            ))}
          </LearnSection>
          <LaunchButton to="/chatbot">
            <LaunchButtonText>Launch SH+ Assistant</LaunchButtonText>
            <ArrowRight color={pallette.text} />
          </LaunchButton>
        </SectionBottom>
      </Container>
    </Layout>
  );
};

export default Landing;
